<br />
<div class="container" *ngIf="cartProducts.length > 0">
  <div class="card">
    <div class="row">
      <div class="col-md-8 cart">
        <div class="title">
          <div class="row">
            <div class="col">
              <h4><b>Carrello</b></h4>
            </div>
            <div class="col align-self-center text-right text-muted">{{ productService.getLocalCartProducts().length}}
            </div>
          </div>
        </div>
        <div class="row border-top border-bottom" *ngFor="let product of cartProducts">
          <div class="row main align-items-center">
            <div class="col-sm-3">
              <a [routerLink]="['/products/product', product.product_id]">
                <img class="img-fluid"
                  [src]="product.thumbnail_picture_url ? product.thumbnail_picture_url : './assets/img/placeholder-image.png'">
              </a>
            </div>
            <div class="col-sm-3">
              <div class="row">{{ product.description | titlecase}}</div>
              <div class="row text-muted">{{ product.product_details['origin'] | titlecase}}</div>
            </div>
            <div class="col-sm-3">
              <div *ngIf="productService.getProductQuantity(product.product_id) > 1; else elseBlock">
              <a (click)="decreaseProductQuantity(product)">-</a><a class="border">{{
                productService.getProductQuantity(product.product_id) }}</a><a
                (click)="increaseProductQuantity(product)">+</a>
              </div>

              <ng-template #elseBlock>
                <a>-</a><a class="border">{{ productService.getProductQuantity(product.product_id) }}</a><a
                  (click)="increaseProductQuantity(product)">+</a>
              </ng-template>
            </div>
            <div class="col-sm-2">&euro; {{product.price}} 
            </div>
            <div class="col-sm-1 align-middle">
              <a><span class="close align-middle"
                (click)="removeCartProduct(product)"><i class="fa fa-trash fa-2x"></i></span></a>
            </div>
          </div>
        </div>
        <div class="back-to-shop"><a [routerLink]="['/products/all-products']"><span class="text-muted">Ritorna ai
              Presepi</span></a></div>
      </div>
      <div class="col-md-4 summary">
        <div>
          <h5><b>Sommario</b></h5>
        </div>
        <hr>
        <div class="row">
          <div class="col" style="padding-left:0;">NUMERO</div>
          <div class="col text-right"> {{ productService.getLocalCartProducts().length}}</div>
        </div>
        <div class="row" style="border-top: 1px solid rgba(0,0,0,.1); padding: 2vh 0;">
          <div class="col" style="padding-left:0;">OFFERTA MINIMA</div>
          <div class="col text-right">&euro; {{ totalValue }}</div>
        </div>
        <button class="btn" [routerLink]="['/products/checkout']">CHECKOUT</button>
      </div>
    </div>
  </div>
</div>
<div class="container" *ngIf="cartProducts.length === 0">
  <app-no-products-found [title]="messageTitle" [description]="messageDescription"></app-no-products-found>
</div>